import type { StoreFeatureConfig } from './type';

export const store: StoreFeatureConfig = {
    isStoreInfoApiSupported: false,
};
